import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'shared/theme'

import SearchSvg from './search.svg'
import { homeLink, searchLink } from 'routing/routes'
import UserMenu from 'shared/components/UserMenu'
import { AuthContext } from 'auth/Auth'
import Logo from './Logo'
import MigrationNotice from './MigrationNotice'

const VerticleAlignCenter = styled.div`
    display: flex;
    align-items: center;
`

const StyledHeader = styled(VerticleAlignCenter)<{
    variant?: 'normal' | 'edit' | 'preview'
}>`
    position: relative;
    padding: 0.5rem 2rem 0.5rem 1.5rem;
    min-height: 4rem;
    justify-content: center;
    background-color: ${({ variant = 'normal', ...props }): string => {
        switch (variant) {
            case 'normal':
                return props.theme.colors.white
            case 'preview':
                return props.theme.colors.gray
            case 'edit':
                return props.theme.colors.textPrimary
        }
    }};
    border-bottom: 1px solid
        ${({ variant = 'normal', ...props }): string => {
            switch (variant) {
                case 'normal':
                    return props.theme.colors.border
                case 'preview':
                    return props.theme.colors.gray
                case 'edit':
                    return props.theme.colors.textPrimary
            }
        }};
`

const HomeLink = styled(Link)`
    font-weight: 400;
    font-size: 1.125rem;
    color: ${props => props.theme.colors.textSecondary};
    margin-right: 1rem;
`

const StyledSearchLink = styled(Link)`
    padding: 0.25rem 0.5rem 0;
    margin-right: 1rem;
`

const HeaderNavAside = styled(VerticleAlignCenter)`
    margin-left: auto;
    z-index: 1;
`

export const HeaderCenter = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: min(42rem, calc(100% - 22rem));
    pointer-events: none;

    a {
        pointer-events: auto;
    }
`

export const HeaderNav = (): React.ReactElement => (
    <HeaderNavAside>
        <HomeLink to={homeLink()}>Home</HomeLink>
        <StyledSearchLink to={searchLink()}>
            <img src={SearchSvg} alt="Search" />
        </StyledSearchLink>
        <UserMenu />
    </HeaderNavAside>
)

export const HeaderMigrationNotice: React.FC = () => (
    <HeaderCenter>
        <MigrationNotice variant="header" />
    </HeaderCenter>
)

const Header: React.FC = (): React.ReactElement => {
    const { signedIn } = React.useContext(AuthContext)

    return (
        <StyledHeader>
            <Logo />
            {signedIn === true && (
                <>
                    <HeaderMigrationNotice />
                    <HeaderNav />
                </>
            )}
        </StyledHeader>
    )
}

export default Header
export { StyledHeader }
